export default __webpack_public_path__ + "images/K7.4dd1c55.png";